import React from 'react';
import { useTranslation } from 'react-i18next';
import InvestorImage from '../../Assets/invest3xp.jpeg';

const InvestmentShowcase = () => {
  const { t } = useTranslation();

  const achievements = [
    {
      k: 'Round',
      title: t('investment.achievements.raised.title', '€1.2M seed'),
      desc: t('investment.achievements.raised.description', 'Closed with a clinical-first mandate.'),
    },
    {
      k: 'Lead',
      title: t('investment.achievements.partner.title', '3xP Global'),
      desc: t('investment.achievements.partner.description', 'Strategic lead investor.'),
    },
    {
      k: 'Focus',
      title: t('investment.achievements.growth.title', 'European hospitals'),
      desc: t('investment.achievements.growth.description', 'Deployed inside the perimeter.'),
    },
    {
      k: 'Team',
      title: t('investment.achievements.team.title', 'Clinical + engineering'),
      desc: t('investment.achievements.team.description', 'Hiring across both disciplines.'),
    },
  ];

  return (
    <section id="investment" className="bf-section">
      <div className="bf-container">
        <div className="bf-section-head">
          <span className="bf-eyebrow"><span className="dot"></span>{t('investment.badge', 'Backed by')}</span>
          <div>
            <h2>
              {t('investment.titleA', 'A €1.2M seed round ')}
              <span className="bf-grad-text">{t('investment.titleB', 'to reach every European hospital.')}</span>
            </h2>
          </div>
        </div>

        <div
          className="bf-invest-top"
          style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'center' }}
        >
          <div>
            <div
              style={{
                fontFamily: 'var(--bf-sans)', fontWeight: 640,
                fontSize: 'clamp(60px, 8vw, 120px)',
                letterSpacing: '-0.04em',
                lineHeight: 1,
                marginBottom: 12,
              }}
              className="bf-grad-text"
            >
              {t('investment.fundingAmount', '€1.2M')}
            </div>
            <div className="bf-small" style={{ color: 'var(--bf-muted)' }}>
              {t('investment.fundingLabel', 'Seed round · 2025 · led by 3xP Global')}
            </div>
          </div>

          <div
            style={{
              border: '1px solid var(--bf-rule)',
              borderRadius: 14,
              overflow: 'hidden',
              background: 'var(--bf-surface)',
            }}
          >
            <img
              src={InvestorImage}
              alt={t('investment.imageAlt', 'Announcement of BloodFlow seed round with 3xP Global')}
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
            <div
              style={{
                padding: '14px 18px',
                borderTop: '1px solid var(--bf-rule)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span className="bf-caption">{t('investment.imageCaption', 'Seed round announcement')}</span>
              <a
                href="https://www.3xpglobal.eu/news/3xp-global-invests-in-bloodflow"
                target="_blank"
                rel="noopener noreferrer"
                className="bf-small"
                style={{
                  color: 'var(--bf-accent)',
                  textDecoration: 'none',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                }}
              >
                {t('investment.cta.readAnnouncement', 'Read announcement')} →
              </a>
            </div>
          </div>
        </div>

        <div
          className="bf-invest-achievements"
          style={{
            marginTop: 64,
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 1,
            background: 'var(--bf-rule)',
            border: '1px solid var(--bf-rule)',
          }}
        >
          {achievements.map((a, i) => (
            <div key={i} style={{ background: 'var(--bf-surface)', padding: '24px 22px' }}>
              <div className="bf-small">{a.k}</div>
              <div
                style={{
                  marginTop: 8,
                  fontFamily: 'var(--bf-sans)', fontWeight: 640,
                  fontSize: 22,
                  letterSpacing: '-0.01em',
                  lineHeight: 1.2,
                  color: 'var(--bf-ink)',
                }}
              >
                {a.title}
              </div>
              <p className="bf-body-p" style={{ marginTop: 6, fontSize: 13.5, color: 'var(--bf-muted)' }}>{a.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .bf-invest-top { grid-template-columns: 1fr !important; gap: 48px !important; }
          .bf-invest-achievements { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 540px) {
          .bf-invest-achievements { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
};

export default InvestmentShowcase;
